import { AnswerSchema, QuestionStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { unsetDialogs } from './services/unsetDialogs'
import { getUsedDialogs } from './services/getUsedDialogs'
import { useFormSchema, useFormUiSchema } from './services/hooks'
import { createStepService } from '../../utils/stepServices/createStepServices'
import { getSubdialogConnectionsMetadata } from './services/getSubdialogConnectionsMetadata'
import {
  useFormSchema as useAnswerFormSchema,
  useFormUiSchema as useAnswerFormUiSchema
} from './services/answer/hooks'

export const questionStepService = createStepService<QuestionStepSchema, { answer: AnswerSchema }>({
  search,

  unsetDialogs,
  getUsedDialogs,
  getSubdialogConnectionsMetadata,

  useFormSchema,
  useFormUiSchema,
  substeps: {
    answer: {
      useFormSchema: useAnswerFormSchema,
      useFormUiSchema: useAnswerFormUiSchema
    }
  }
})
